import { NavArrowRightIcon, RightArrowIcon } from '@sketchnote/icons';
import { ContainerFixedMargin } from '@sketchnote/shared-components';
import Link from 'next/link';
import React from 'react';

import { HelpComponent } from '../../components';
import { Footer, FooterSecondary, Header } from '../../components';

export const Help = (): JSX.Element => {
  return (
    <div>
      <Header />
      <div className="bg-gray-199 border">
        <div className="relative bigScreen:max-w-1400 bigScreen:mx-auto  flex  desktop:flex-row laptop:flex-row tablet:flex-col mobile:flex-col justify-between bg-gray-199 mobile:h-415 laptop:h-332">
          <div className="laptop:pt-107 laptop:pl-36 tablet:pt-107 tablet:pl-36 mobile:pt-107 mobile:pl-24 desktop:pt-90 desktop:pl-144 bigScreen:pl-200">
            <span
              style={{ lineHeight: '100%' }}
              className=" text-blue-700 mb-36 desktop:text-10xl mobile:text-6xl font-bold block desktop:pt-64"
            >
              How can we <span className="text-blue-500">help?</span>
            </span>
          </div>
          <img
            src="https://res.cloudinary.com/samvibes/image/upload/landing/hero-mobile.png"
            alt="Nancy Newman handing out fliers with resources written on it."
            className="z-10 absolute mobile:top-138 self-end  laptop:hidden tablet:inline-block truncate contain mobile:h-336"
          />
          <div className="relative">
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/landing/Help/hero.png"
              alt="Nancy Newman handing out fliers with resources written on it."
              className="z-20 absolute laptop:block mobile:hidden truncate desktop:h-332 desktop:top-70 laptop:top-70 laptop:h-332 "
            />
            <img
              src="https://res.cloudinary.com/samvibes/image/upload/landing/Help/help_background.png"
              alt="yellow background"
              className="self-end  laptop:h-332 desktop:h-330  laptop:inline-block mobile:hidden truncate "
            />
          </div>
        </div>
      </div>
      <ContainerFixedMargin className="desktop:py-68 mobile:py-58 ">
        <p className="mb-32 bigScreen:ml-82 laptop:ml-32 mobile:text-center bigScreen:text-left font-bold text-blue-800 laptop:text-4xl mobile:text-2xl">
          Explore our resources
        </p>

        <div className="flex flex-wrap justify-start bigScreen:pl-52">
          <HelpComponent
            heading={'GETTING STARTED'}
            contentOne={'First steps on your Sketchnote journey'}
            contentTwo={'Setting up your organization, workspace and adding teammates'}
            contentThree={'Adding guests and sharing Sketchnote'}
            link={
              'https://docs.sketchnote.co/getting-started/first-steps-on-your-sketchnote-journey'
            }
            linkOne={
              'https://docs.sketchnote.co/getting-started/first-steps-on-your-sketchnote-journey'
            }
            linkTwo={
              'https://docs.sketchnote.co/getting-started/setting-up-your-organization-and-adding-teammates'
            }
            linkThree={
              'https://docs.sketchnote.co/getting-started/adding-guests-and-sharing-sketchnote'
            }
            icon="https://res.cloudinary.com/samvibes/image/upload/v1625462732/landing/Help/help_icon_1.png"
          />
          <HelpComponent
            heading={'SKETCHNOTE DASHBOARDS'}
            contentOne={'Workstation dashboard'}
            contentTwo={'Academy dashboard'}
            contentThree={'Notifications, help and organizations'}
            linkOne={'https://docs.sketchnote.co/dashboards/the-workstation-dashboard'}
            linkTwo={'https://docs.sketchnote.co/dashboards/the-academy-dashboard'}
            linkThree={'https://docs.sketchnote.co/dashboards/notifications-help-and-organizations'}
            link={'https://docs.sketchnote.co/dashboards/the-workstation-dashboard'}
            icon="https://res.cloudinary.com/samvibes/image/upload/v1625462732/landing/Help/help_icon_2.png"
          />
          <HelpComponent
            heading={'FILES'}
            linkOne={'https://docs.sketchnote.co/files/file-basics'}
            linkTwo={'https://docs.sketchnote.co/files/customizing-files'}
            linkThree={'https://docs.sketchnote.co/files/sharing-files'}
            contentOne={'File basics'}
            contentTwo={'Customizing files'}
            contentThree={'Sharing files'}
            link={'https://docs.sketchnote.co/files/file-basics'}
            icon="https://res.cloudinary.com/samvibes/image/upload/v1625462732/landing/Help/help_icon_3.png"
          />

          <HelpComponent
            heading={'VIEWS'}
            linkOne={'https://docs.sketchnote.co/views/page-views'}
            linkTwo={'https://docs.sketchnote.co/views/task-views'}
            linkThree={'https://docs.sketchnote.co/views/timesheet-and-analytics'}
            contentOne={'Page views'}
            contentTwo={'Task views'}
            contentThree={'Timesheet and Analytics'}
            link={'https://docs.sketchnote.co/views/page-views'}
            icon="https://res.cloudinary.com/samvibes/image/upload/v1625462732/landing/Help/help_icon_4.png"
          />
          <HelpComponent
            heading={'TASKS'}
            linkOne={'https://docs.sketchnote.co/tasks/task-basics'}
            linkTwo={'https://docs.sketchnote.co/tasks/collaborating-on-tasks'}
            linkThree={'https://docs.sketchnote.co/tasks/custom-fields-in-tasks'}
            contentOne={'Task basics'}
            contentTwo={'Collaboration'}
            contentThree={'Custom fields'}
            link={'https://docs.sketchnote.co/tasks/task-basics'}
            icon="https://res.cloudinary.com/samvibes/image/upload/v1625462732/landing/Help/help_icon_5.png"
          />

          <HelpComponent
            heading={'LESSONS AND LEGAL TEMPLATES'}
            linkOne={
              'https://docs.sketchnote.co/lessons-and-legal-templates/all-about-sketchnote-lessons'
            }
            linkTwo={'https://docs.sketchnote.co/lessons-and-legal-templates/lesson-templates'}
            linkThree={
              'https://docs.sketchnote.co/lessons-and-legal-templates/using-legal-templates'
            }
            contentOne={'Lesson basics'}
            contentTwo={'Lesson templates'}
            contentThree={'Using legal templates'}
            link={
              'https://docs.sketchnote.co/lessons-and-legal-templates/all-about-sketchnote-lessons'
            }
            icon="https://res.cloudinary.com/samvibes/image/upload/v1625462732/landing/Help/help_icon_6.png"
          />
          <HelpComponent
            heading={'SETTINGS AND PREFERENCES'}
            linkOne={
              'https://docs.sketchnote.co/settings-and-preferences/customize-your-sketchnote-profile'
            }
            linkTwo={
              'https://docs.sketchnote.co/settings-and-preferences/customize-your-sketchnote-organization'
            }
            linkThree={
              'https://docs.sketchnote.co/settings-and-preferences/sketchnote-integrations'
            }
            contentOne={'Customizing your profile'}
            contentTwo={'Customizing your organization'}
            contentThree={'Integrations'}
            link={
              'https://docs.sketchnote.co/settings-and-preferences/customize-your-sketchnote-profile'
            }
            icon="https://res.cloudinary.com/samvibes/image/upload/v1625462732/landing/Help/help_icon_6.png"
          />
        </div>
      </ContainerFixedMargin>
      <img
        src="https://res.cloudinary.com/samvibes/image/upload/landing/help_curve1.png"
        alt="gray curve"
        className="w-full"
      />
      <div className="bg-gray-199 w-full">
        <ContainerFixedMargin>
          <div className="desktop:w-864 mx-auto tablet:w-full mobile:w-full desktop:-mt-16 mobile:pt-58 desktop:pt-0">
            <p className="font-bold text-blue-800  mb-32 desktop:text-4xl laptop:text-4xl tablet:text-2xl mobile:text-2xl">
              FAQs
            </p>

            <Link
              href={
                'https://docs.sketchnote.co/settings-and-preferences/faqs#how-do-i-use-sketchnote-with-my-team'
              }
            >
              <a className="flex justify-between py-24 border-b text-gray-600 hover:text-blue-500">
                <span
                  role="img"
                  aria-label="faq"
                  className="mobile:max-w-284 tablet:max-w-810  text-lg"
                >
                  👔 How do I use Sketchnote with my team?
                </span>
                <NavArrowRightIcon />
              </a>
            </Link>
            <Link
              href={
                'https://docs.sketchnote.co/settings-and-preferences/faqs#what-plans-are-available-on-sketchnote-right-now'
              }
            >
              <a className="flex justify-between py-24 border-b text-gray-600 hover:text-blue-500">
                <span
                  role="img"
                  aria-label="faq"
                  className="mobile:max-w-284 tablet:max-w-810  text-lg"
                >
                  📈 What plans are available on Sketchnote right now?
                </span>
                <NavArrowRightIcon />
              </a>
            </Link>
            <Link
              href={
                'https://docs.sketchnote.co/settings-and-preferences/faqs#can-i-invite-guests-to-my-sketchnote-organization-and-share-files'
              }
            >
              <a className="flex justify-between py-24 border-b text-gray-600 hover:text-blue-500">
                <span
                  role="img"
                  aria-label="faq"
                  className="mobile:max-w-284 tablet:max-w-810  text-lg"
                >
                  💸 Can I invite guests to my Sketchnote organization and share files?
                </span>
                <NavArrowRightIcon />
              </a>
            </Link>
            <Link
              href={
                'https://docs.sketchnote.co/settings-and-preferences/faqs#how-much-storage-space-do-i-have-on-sketchnote-docs'
              }
            >
              <a className="flex justify-between py-24 border-b text-gray-600 hover:text-blue-500">
                <span
                  role="img"
                  aria-label="faq"
                  className="mobile:max-w-284 tablet:max-w-810  text-lg"
                >
                  📃 How much storage space do I have on Sketchnote?
                </span>
                <NavArrowRightIcon />
              </a>
            </Link>
            <Link
              href={
                'https://docs.sketchnote.co/settings-and-preferences/faqs#can-i-get-a-custom-domain-name-for-my-organization-on-sketchnote'
              }
            >
              <a className="flex justify-between py-24 border-b text-gray-600 hover:text-blue-500">
                <span
                  role="img"
                  aria-label="faq"
                  className="mobile:max-w-284 tablet:max-w-810 text-lg"
                >
                  🔑 Can I get a custom domain name for my organization on Sketchnote?
                </span>
                <NavArrowRightIcon />
              </a>
            </Link>
            <Link
              href={
                'https://docs.sketchnote.co/settings-and-preferences/faqs#how-many-members-can-i-add-to-my-free-account'
              }
            >
              <a className="mb-32 flex justify-between pt-24 text-gray-600 hover:text-blue-500">
                <span
                  role="img"
                  aria-label="faq"
                  className="mobile:max-w-284 tablet:max-w-810 text-lg"
                >
                  📈 How many members can I add to my free account?
                </span>
                <NavArrowRightIcon />
              </a>
            </Link>
            <Link href={'https://docs.sketchnote.co/settings-and-preferences/faqs'}>
              <a className="text-blue-500 text-sm font-medium inline-block mobile:pb-58 desktop:pb-0">
                <span>View more&nbsp;</span>
                <RightArrowIcon className="text-sm text-blue-500 ml-10 pt-4 " />
              </a>
            </Link>
          </div>
        </ContainerFixedMargin>
      </div>
      <img
        src="https://res.cloudinary.com/samvibes/image/upload/landing/help_curve2.png"
        alt="gray curve"
        className="w-full desktop:-mt-2 "
      />
      <div
        style={{ backgroundColor: '#FBFBF8' }}
        className="mobile:mx-24 shadow-lg  laptop:mt-128 mobile:mt-58 laptop:mb-112 mobile:mb-68 rounded-lg laptop:mx-36  desktop:mx-auto flex desktop:w-864 desktop:h-284 overflow-visible desktop:flex-row laptop:flex-row tablet:flex-col mobile:flex-col"
      >
        <div className="p-32">
          <p className="text-blue-800  mb-16 font-bold text-4xl">
            <span
              role="img"
              aria-label="category"
              className="text-primary-500 text-2xl font-bold mb-8 mobile:text-xl block "
            >
              More help?
            </span>
            Contact our customer service.
          </p>
          <Link href={'https://sketchnote.co/forms/636cf35095845f348e2221c8'}>
            <a
              target="_blank"
              className="text-blue-500 text-sm font-medium mb-24 mobile:mb-24 desktop:mb-0 block"
            >
              <span>Contact us</span>
              <RightArrowIcon className="text-sm text-blue-500 ml-8 pt-4" />
            </a>
          </Link>
        </div>
        <img
          src="https://res.cloudinary.com/samvibes/image/upload/landing/Help/sketchnote-contact-us.png"
          alt="Lucy Lee looking up Sketchnote's customer service on a laptop"
          className="-mt-64 mobile:mx-auto desktop:h-332 desktop:max-w-500 laptop:h-332 laptop:max-w-500 tablet:max-w-332 mobile:max-w-284"
        />
      </div>
      <FooterSecondary />
      <Footer />
    </div>
  );
};
